import React, { useCallback, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../style/custommillingHubdashboard.css";
import "../../style/customresponsivefile.css";
import "../../style/addrestoration.css";
import "../../style/addmaterial.css";
import type { ManagerScheduledOrder } from "./interface/ScheduledOrder ";
import { useScheduledOrders } from "./hooks/useScheduledOrders";
import ScheduleOrdersFilters from "./components/ScheduleOrdersFilters";
import ScheduleOrdersTable from "./components/ScheduleOrdersTable";
import OrderDetailsModal from "./components/OrderDetailsModal";
import ScheduledScanUploadModal from "./components/ScheduledScanUploadModal";
const ScheduleOrdersList: React.FC = () => { 
  const {orders,loading,search,setSearch,startDate,setStartDate,endDate,setEndDate,clearFilters,
    uploadScheduledScans,} = useScheduledOrders();
  const [selectedOrder, setSelectedOrder] =useState<ManagerScheduledOrder | null>(null);
  const [uploadOrder, setUploadOrder] =useState<ManagerScheduledOrder | null>(null);
  const handleRowClick = useCallback((order: ManagerScheduledOrder) => {if (!uploadOrder) {
        setSelectedOrder(order);
      }
    },
    [uploadOrder]
  );
  const handleUploadClick = useCallback((order: ManagerScheduledOrder) => {
      setSelectedOrder(null);
      setUploadOrder(order);
    },
    []
  );
  const handleUpload = useCallback(
    async (caseID: number, files: File[]) => {
      return uploadScheduledScans(caseID, files);
    },
    [uploadScheduledScans]
  );
  const closeUploadModal = useCallback(() => {
    setUploadOrder(null);
  }, []);

  return (
    <div className="manager-schedule-page mt-1">
      <div className="manager-schedule-heading mb-3">
        <div>
          <h4 className="mb-1">Schedule Orders List</h4>
          <p className="mb-0">
            View scheduled orders, clinics and payment details.
          </p>
        </div>
      </div>

      <ScheduleOrdersFilters
        startDate={startDate}
        endDate={endDate}
        search={search}
        loading={loading}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        onSearchChange={setSearch}
        onClear={clearFilters}
      />

      <ScheduleOrdersTable
        orders={orders}
        loading={loading}
        onRowClick={handleRowClick}
        onUploadClick={handleUploadClick}
      />

      {selectedOrder && !uploadOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}

      {uploadOrder && (
        <ScheduledScanUploadModal
          order={uploadOrder}
          onClose={closeUploadModal}
          onUpload={handleUpload}
        />
      )}
    </div>
  );
};

export default ScheduleOrdersList;
